<template>
    <component
        :is="is2.is"
        v-bind="is2.bind"
        :data="data"
        :has-eager-image="hasEagerImage"
    />
</template>

<script lang="ts" setup>
import type { SquareBoxesFragment } from '@/graphql/api'
import { computed } from 'vue'
import { assertNever } from '@/helpers'
import DebugComponent from '@/components/cms/component/DebugComponent.vue'
import SquareImageBox from '@/components/cms/component/square-boxes/SquareImageBox.vue'
import SquareTextBox from '@/components/cms/component/square-boxes/SquareTextBox.vue'
import { getComponent } from '@/types/vue.ts'
import { type PageType } from '@/components/cms/component/content/ContentButton.vue'

const props = defineProps<{
    data: SquareBoxesFragment
    hasEagerImage?: boolean
    pageType: PageType
}>()

const is2 = computed(() => {
    const type = props.data.__typename

    switch (type) {
        case 'SquareImageBox':
            return getComponent(SquareImageBox, {
                data: props.data,
                hasEagerImage: props.hasEagerImage,
            })
        case 'SquareTextBox':
            return getComponent(SquareTextBox, {
                data: props.data,
                hasEagerImage: props.hasEagerImage,
                pageType: props.pageType,
            })
        default:
            return assertNever(type, DebugComponent)
    }
})
</script>
